import { render } from "./MentalBackgroundLayout.vue?vue&type=template&id=011dc67a"
import script from "./MentalBackgroundLayout.vue?vue&type=script&lang=js"
export * from "./MentalBackgroundLayout.vue?vue&type=script&lang=js"

import "./MentalBackgroundLayout.vue?vue&type=style&index=0&id=011dc67a&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__